import { formatBytes, formatTimestamp, type Backup, type Instance } from '@gsp/shared';
import { Empty, SectionLabel } from '../components/basics.js';

export function Backups({
  instance,
  backups,
  busy,
  onUpdate,
  onCreate,
  onRestore,
  onDelete,
}: {
  instance: Instance;
  backups: Backup[];
  busy: boolean;
  onUpdate: () => void;
  onCreate: () => void;
  onRestore: (backup: Backup) => void;
  onDelete: (backup: Backup) => void;
}) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--s-8)' }}>
      <section className="panel detailhead">
        <div>
          <div className="tile__label">Version</div>
          <div className="tile__value tile__value--small">{instance.version}</div>
          <div className={`tile__foot${instance.updateAvailable ? ' tile__foot--warn' : ''}`}>
            {instance.updateNote}
          </div>
        </div>
        <div className="detailhead__actions">
          <button
            type="button"
            className="button button--primary"
            disabled={instance.updating || busy}
            onClick={onUpdate}
          >
            {instance.updating ? 'Update läuft…' : 'Update installieren'}
          </button>
          <button
            type="button"
            className="button button--secondary"
            disabled={busy}
            onClick={onCreate}
          >
            Backup erstellen
          </button>
        </div>
      </section>

      <section style={{ display: 'flex', flexDirection: 'column', gap: 'var(--s-4)' }}>
        <SectionLabel text="Snapshots" right={instance.backupSchedule} />
        <div className="rows">
          {backups.length === 0 && <Empty text="noch keine Snapshots" />}
          {backups.map((backup) => (
            <div className="row" key={backup.id}>
              <span className="row__file" title={backup.file}>
                {backup.file}
              </span>
              <span className="row__time">{formatTimestamp(backup.createdAt)}</span>
              <span className="row__size">{formatBytes(backup.sizeBytes)}</span>
              <span className={`row__kind row__kind--${backup.kind}`}>
                {backup.kind === 'manuell' ? 'Manuell' : 'Auto'}
              </span>
              <button
                type="button"
                className="button button--small"
                disabled={busy}
                onClick={() => onRestore(backup)}
              >
                Restore
              </button>
              <button
                type="button"
                className="button button--small button--small-danger"
                disabled={busy}
                onClick={() => onDelete(backup)}
              >
                Löschen
              </button>
            </div>
          ))}
        </div>
        <p className="hint">
          Eine Wiederherstellung stoppt die Instanz, ersetzt die Weltdaten und startet sie danach wieder.
        </p>
      </section>
    </div>
  );
}
